import { FiatTransactionStatus } from '@bts-web/data-layer/server';
import { TradeScreenTranslations } from './getTradeTranslations';

export const getTransferStatusDescription = (
  status: FiatTransactionStatus,
  translations: TradeScreenTranslations,
): string | undefined => {
  const map: Partial<Record<FiatTransactionStatus, string>> = {
    REJECTED: translations.fiatTransferRejectedStatusDescription,
    REFUNDED: translations.fiatTransferRefundedStatusDescription,
    CANCELLED: translations.fiatTransferRejectedStatusDescription,
  };

  // Return undefined for unmapped statuses (e.g. INITIATED on a network error)
  // so callers show a generic message instead of the raw enum string.
  return map[status];
};
